import { IonApp, IonButton, IonCol, IonRow, IonText } from "@ionic/react";

import { ErrorScoopAnimation } from "@/components/scoop-animation/ErrorScoopAnimation";
import "@/components/scoop-animation/scoop-animation-shared.css";
import {
  LogRegHeader,
  LogRegPageLayout,
} from "@/pages/login/components/LoginRegisterLayout";
import { SUPPORT_EMAIL } from "@/utils/constants/app";

type AppErrorFallbackProps = {
  error?: unknown;
  onRetry?: () => void;
};

function AppErrorFallback({ error, onRetry }: AppErrorFallbackProps) {
  return (
    <IonApp>
      <LogRegPageLayout>
        <ErrorScoopAnimation />
        <LogRegHeader
          title="Something went wrong"
          subHeader="An unexpected error occurred. You can try again or reload the page."
        />
        <IonRow className="content-sub-block ion-justify-content-center">
          <IonCol className="ion-text-center" size="auto">
            {onRetry ? (
              <IonButton onClick={onRetry}>Try again</IonButton>
            ) : null}
            <IonButton
              fill={onRetry ? "outline" : "solid"}
              onClick={() => {
                window.location.reload();
              }}
            >
              Reload page
            </IonButton>
          </IonCol>
        </IonRow>
        <IonRow className="content-sub-block ion-justify-content-center">
          <IonCol className="ion-text-center" size="auto">
            <IonText>If the problem persists, email </IonText>
            <IonButton
              className="scoop-support-email"
              fill="clear"
              href={`mailto:${SUPPORT_EMAIL}`}
            >
              {SUPPORT_EMAIL}
            </IonButton>
          </IonCol>
        </IonRow>
        {import.meta.env.DEV && error ? (
          <IonRow className="ion-justify-content-center ion-padding">
            <IonCol size="12">
              <IonText color="medium">
                <pre>
                  {error instanceof Error ? error.message : String(error)}
                </pre>
              </IonText>
            </IonCol>
          </IonRow>
        ) : null}
      </LogRegPageLayout>
    </IonApp>
  );
}

export { AppErrorFallback };
